import { appOrigin } from "@garimpa/lib/appOrigin";

const ABSOLUTE_URL_PATTERN = /^[a-z][a-z\d+\-.]*:/i;

export { appOrigin };

export function toAbsoluteUrl(path: string): string;
export function toAbsoluteUrl(path: string | null | undefined): string | null;
export function toAbsoluteUrl(path: string | null | undefined): string | null {
  if (path == null) return null;
  if (ABSOLUTE_URL_PATTERN.test(path)) return path;
  if (path.startsWith("//")) return `${new URL(appOrigin()).protocol}${path}`;
  return `${appOrigin()}${path.startsWith("/") ? path : `/${path}`}`;
}
